import ScenariosScreen from './ScenariosScreen';
import React from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { canAccessAdminRoute, isExerciseEditor } from '../../config/adminRoles';

import AdminDashboardScreen from './AdminDashboardScreen';
import ExerciseListScreen from './ExerciseListScreen';
import ExerciseDetailScreen from './ExerciseDetailScreen';
import UserListScreen from './UserListScreen';
import UserNavigationHistory from './UserNavigationHistory';
import AdminStatsScreen from './AdminStatsScreen';
import PromptEngineeringScreen from './PromptEngineeringScreen';
import MarketingScreen from './MarketingScreen';
import AdventureScreen from './AdventureScreen';
import ProductsAuditScreen from './ProductsAuditScreen';
import GrimoireScreen from './GrimoireScreen';
import ImpressionsScreen from './ImpressionsScreen';
import OffresDuMomentScreen from './OffresDuMomentScreen';
import ParentFeedbackScreen from './ParentFeedbackScreen';
import ContentReportsScreen from './ContentReportsScreen';
import ExerciseTaxonomyScreen from './ExerciseTaxonomyScreen';
import ExerciseStudioScreen from './ExerciseStudioScreen';
import ServingGapsScreen from './ServingGapsScreen';
import NotionsDemandeesScreen from './NotionsDemandeesScreen';
import TaxonomyReferentialScreen from './TaxonomyReferentialScreen';
import CatalogItemsScreen from './CatalogItemsScreen';
import ErrorClassificationHarnessScreen from './ErrorClassificationHarnessScreen';
import TeacherPagesScreen from './TeacherPagesScreen';
import EtablissementsScreen from './EtablissementsScreen';
import ConsommationIAScreen from './ConsommationIAScreen';
import EntonnoirAchatScreen from './EntonnoirAchatScreen';

const AdminRoutes = () => {
  const { user, isAdmin, adminRole, checking } = useAuth();
  const location = useLocation();

  if (checking) {
    return <div>Vérification des droits d'administration...</div>;
  }

  if (!user || !isAdmin) {
    return <Navigate to="/login" replace />;
  }

  const defaultPath = isExerciseEditor(adminRole) ? '/admin/exercises' : '/admin';

  if (!canAccessAdminRoute(location.pathname, adminRole)) {
    return <Navigate to={defaultPath} replace />;
  }

  const defaultRelativePath = isExerciseEditor(adminRole) ? 'exercises' : '';

  return (
    <Routes>
      <Route
        index
        element={
          isExerciseEditor(adminRole)
            ? <Navigate to="exercises" replace relative="path" />
            : <AdminDashboardScreen />
        }
      />
      <Route path="exercises" element={<ExerciseListScreen />} />
      <Route path="exercise-taxonomy" element={<ExerciseTaxonomyScreen />} />
      <Route path="exercises/studio" element={<ExerciseStudioScreen />} />
      <Route path="exercises/create" element={<ExerciseDetailScreen />} />
      <Route path="exercises/edit/:id" element={<ExerciseDetailScreen />} />
      <Route path="exercises/view/:id" element={<ExerciseDetailScreen />} />
      <Route path="users" element={<UserListScreen />} />
      {/* File de revue des signalements — exigence des stores pour tout UGC. */}
      <Route path="signalements" element={<ContentReportsScreen />} />
      <Route path="users/:userId/history" element={<UserNavigationHistory />} />
      <Route path="stats" element={<AdminStatsScreen />} />
      <Route path="consommation-ia" element={<ConsommationIAScreen />} />
      <Route path="entonnoir-achat" element={<EntonnoirAchatScreen />} />
      <Route path="prompt-engineering" element={<PromptEngineeringScreen />} />
      <Route path="marketing" element={<MarketingScreen />} />
      <Route path="teacher-pages" element={<TeacherPagesScreen />} />
      <Route path="etablissements" element={<EtablissementsScreen />} />
      <Route path="scenarios" element={<ScenariosScreen />} />
      <Route path="adventures" element={<AdventureScreen />} />
      <Route path="products-audit" element={<ProductsAuditScreen />} />
      <Route path="grimoire" element={<GrimoireScreen />} />
      <Route path="impressions" element={<ImpressionsScreen />} />
      <Route path="offres-du-moment" element={<OffresDuMomentScreen />} />
      <Route path="catalog-items" element={<CatalogItemsScreen />} />
      <Route path="parent-feedbacks" element={<ParentFeedbackScreen />} />
      <Route path="serving-gaps" element={<ServingGapsScreen />} />
      <Route path="notions-demandees" element={<NotionsDemandeesScreen />} />
      <Route path="taxonomy-referential" element={<TaxonomyReferentialScreen />} />
      <Route path="error-classification" element={<ErrorClassificationHarnessScreen />} />
      <Route path="*" element={<Navigate to={defaultRelativePath} replace relative="path" />} />
    </Routes>
  );
};

export default AdminRoutes;
